import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminSteps from '../common/AdminSteps';
import { Row, Col, Table } from 'react-bootstrap';
import * as courseActions from '../../actions/coursesActionCreators';
import * as runActions from '../../actions/runsActionCreators';
import Spinner from 'react-spinkit';
import CustomPagination from '../common/CustomPagination';
import { browserHistory } from 'react-router';
import config from '../../config';

class ClassesPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      coursesLoaded: false,
      courses: [],
      startCourses: 0,
      endCourses: config.tableRowsNum,
      activeCoursePage: 1,
      slug: {
        up: false,
        down: false,
        idle: true
      },
      longname: {
        up: false,
        down: false,
        idle: true
      },
      instructor: {
        up: false,
        down: false,
        idle: true
      },
      weight: {
        up: false,
        down: false,
        idle: true
      },
      target_capacity: {
        up: false,
        down: false,
        idle: true
      },
      requesting_students: {
        up: false,
        down: false,
        idle: true
      },
      assigned_students: {
        up: false,
        down: false,
        idle: true
      },
      waitlisted_students: {
        up: false,
        down: false,
        idle: true
      }
    };

    this.handleCourseSearch = this.handleCourseSearch.bind(this);
    this.searchCourses = this.searchCourses.bind(this);
    this.setCoursesToState = this.setCoursesToState.bind(this);
    this.pageBack = this.pageBack.bind(this);
    this.pageForward = this.pageForward.bind(this);

    this.reorder = this.reorder.bind(this);
    this.sortByKeyAndDirection = this.sortByKeyAndDirection.bind(this);
    this.checkKey = this.checkKey.bind(this);
  }
  componentWillMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
    if (this.props.courses.length < 1) {
      this.props.courseActions.getAllCourses().then(() => {
        this.setState({ coursesLoaded: true });
      });
    } else {
      this.setState({ coursesLoaded: true });
    }
    this.setCoursesToState(this.props.courses);
    document.onkeydown = this.checkKey;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.courses != this.props.courses) {
      this.setCoursesToState(nextProps.courses);
      this.setState({ coursesLoaded: true });
    }
  }

  checkKey(e) {
    if (this.refs.courses) {
      e = e || window.event;
      if (e.keyCode == '37') {
        // left arrow
        if (this.state.activeCoursePage > 1) {
          this.pageBack();
        }
      } else if (e.keyCode == '39') {
        // right arrow
        if (this.state.activeCoursePage < Math.ceil(this.state.courses.length / config.tableRowsNum)) {
          this.pageForward();
        }
      }
    }
  }

  handleCourseSearch(e) {
    e.preventDefault();
    let term = e.target.value;
    if (term != '') {
      let arrUnique = this.searchCourses(term, this.props.courses);

      this.setState({
        courses: arrUnique,
        startCourses: 0,
        endCourses: config.tableRowsNum,
        activeCoursePage: 1
      });
    } else {
      // this.props.courseActions.getAllCourses();
      this.setCoursesToState(this.props.courses);
    }
  }

  searchCourses(term, courses) {
    let b = courses.filter(course => {
      return (
        course.slug.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        course.longname.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        course.instructor.toLowerCase().indexOf(term.toLowerCase()) != -1
      );
    });
    return b;
  }

  setCoursesToState(courses) {
    this.setState({ courses: courses });
  }

  pageBack() {
    let newActivePage = this.state.activeCoursePage - 1;
    this.setState({ activeCoursePage: newActivePage });
    if (newActivePage == 1) {
      this.setState({ startCourses: 0, endCourses: config.tableRowsNum });
    } else {
      let start = newActivePage * config.tableRowsNum - config.tableRowsNum;
      let end = newActivePage * config.tableRowsNum;
      this.setState({ startCourses: start, endCourses: end });
    }
  }
  pageForward() {
    let newActivePage = this.state.activeCoursePage + 1;
    this.setState({ activeCoursePage: newActivePage });
    let start = newActivePage * config.tableRowsNum - config.tableRowsNum;
    let end = newActivePage * config.tableRowsNum;
    this.setState({ startCourses: start, endCourses: end });
  }

  // Ordering
  reorder = column => () => {
    if (this.state[column].idle) {
      this.setState({
        [column]: {
          up: true,
          down: false,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'up');
      this.setState({ courses: a });
    } else if (this.state[column].up) {
      this.setState({
        [column]: {
          up: false,
          down: true,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'down');
      this.setState({ courses: a });
    } else if (this.state[column].down) {
      this.setState({
        [column]: {
          up: true,
          down: false,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'up');
      this.setState({ courses: a });
    }
    let obj = {
      slug: {
        up: false,
        down: false,
        idle: true
      },
      longname: {
        up: false,
        down: false,
        idle: true
      },
      instructor: {
        up: false,
        down: false,
        idle: true
      },
      weight: {
        up: false,
        down: false,
        idle: true
      },
      target_capacity: {
        up: false,
        down: false,
        idle: true
      },
      requesting_students: {
        up: false,
        down: false,
        idle: true
      },
      assigned_students: {
        up: false,
        down: false,
        idle: true
      }
    };

    delete obj[column];
    this.setState(obj);

    // Reset pagination
    this.setState({
      startCourses: 0,
      endCourses: config.tableRowsNum,
      activeCoursePage: 1
    });
  };

  sortByKeyAndDirection(array, key, direction) {
    return array.sort(function(a, b) {
      var x = a[key];
      var y = b[key];
      if (direction == 'up') {
        return x < y ? -1 : x > y ? 1 : 0;
      } else if (direction == 'down') {
        return x > y ? -1 : x < y ? 1 : 0;
      }
    });
  }

  handleEditClass = course => () => {
    browserHistory.push('/administer/' + localStorage.getItem('run') + '/class/' + course.id);
  };
  addClass() {
    browserHistory.push('/administer/' + localStorage.getItem('run') + '/class/');
  }

  render() {
    const { assignment_complete } = this.props.run;

    return (
      <Col md={12}>
        <div className="page-title">Manage Classes</div>
        <AdminSteps active="1" label={this.props.run.slug} assignment_complete={assignment_complete} />
        <Row>
          <Col md={10}>
            <div className="form-group search">
              <span className="fa fa-search" />
              <input
                name="conflictSearchInput"
                onChange={e => {
                  this.handleCourseSearch(e);
                }}
                type="text"
                className="form-control search"
                placeholder="Type name, description or instructor..."
              />
              <span className="input-description">Type name, description or instructor to filter courses</span>
            </div>
          </Col>
          <Col md={2}>
            <button
              type="button"
              className="btn btn-block btn-ter"
              onClick={() => {
                this.addClass();
              }}
            >
              Add Class
            </button>
          </Col>
        </Row>

        <Row ref="courses" className="height480">
          {this.state.coursesLoaded ? (
            <Col md={12}>
              {this.props.courses.length > 0 ? (
                <div className="c-table classes-table">
                  <Table condensed hover>
                    <thead>
                      <tr>
                        <th className="name" onClick={this.reorder('slug')}>
                          <span>
                            Name {this.state.slug.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.slug.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.slug.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        <th onClick={this.reorder('longname')}>
                          <span>
                            Description {this.state.longname.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.longname.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.longname.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        <th onClick={this.reorder('instructor')}>
                          <span>
                            Instructor {this.state.instructor.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.instructor.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.instructor.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        <th onClick={this.reorder('weight')}>
                          <span>
                            Credits {this.state.weight.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.weight.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.weight.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        <th onClick={this.reorder('target_capacity')}>
                          <span>
                            Capacity {this.state.target_capacity.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.target_capacity.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.target_capacity.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        {!assignment_complete && (
                          <th onClick={this.reorder('requesting_students')}>
                            <span>
                              Rankings {this.state.requesting_students.up ? <i className="fa fa-sort-up" /> : null}
                              {this.state.requesting_students.down ? <i className="fa fa-sort-down" /> : null}{' '}
                              {this.state.requesting_students.idle ? <i className="fa fa-sort" /> : null}
                            </span>
                          </th>
                        )}
                        {assignment_complete && (
                          <th onClick={this.reorder('assigned_students')}>
                          <span>
                            Assignments{this.state.assigned_students.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.assigned_students.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.assigned_students.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        )}
                        {assignment_complete && (
                          <th onClick={this.reorder('waitlisted_students')}>
                            <span>
                              Waitlists{this.state.waitlisted_students.up ? <i className="fa fa-sort-up" /> : null}
                              {this.state.waitlisted_students.down ? <i className="fa fa-sort-down" /> : null}{' '}
                              {this.state.waitlisted_students.idle ? <i className="fa fa-sort" /> : null}
                            </span>
                          </th>
                        )}
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.courses.slice(this.state.startCourses, this.state.endCourses).map((course, index) => {
                        return (
                          <tr key={index}>
                            <td className="class-name">
                              <span onClick={this.handleEditClass(course)}>{course.slug}</span>
                            </td>
                            <td className="class-desc">{course.longname}</td>
                            <td className="class-desc">{course.instructor}</td>
                            <td className="class-desc">{course.weight}</td>
                            {assignment_complete && <td className="class-desc">{course.target_capacity}</td>}
                            {!assignment_complete && (
                              <td className="class-desc">
                                {course.target_capacity == course.max_capacity || course.max_capacity == null
                                  ? course.target_capacity
                                  : `${course.target_capacity}/${course.max_capacity}`}
                              </td>
                            )}
                            {!assignment_complete && <td className="class-desc">{course.requesting_students}</td>}
                            {assignment_complete && <td className="class-desc">{course.assigned_students}</td>}
                            {assignment_complete && <td className="class-desc">{ course.waitlisted_students}</td>}
                            <td className="class-edit">
                              <span onClick={this.handleEditClass(course)}>Edit</span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <CustomPagination
                    activePage={this.state.activeCoursePage}
                    onBack={this.pageBack}
                    onForward={this.pageForward}
                    listLength={Math.ceil(this.state.courses.length / config.tableRowsNum)}
                  />
                </div>
              ) : (
                <div className="text-center">No Classes</div>
              )}
            </Col>
          ) : (
            <div className="spinner-box">
              <Spinner spinnerName="three-bounce" className="mt-4" />
            </div>
          )}
        </Row>
      </Col>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    courses: state.courses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassesPage);



// WEBPACK FOOTER //
// ./src/components/classes/ClassesPage.js